import type { Editor } from "@repo/fika-blog/src/tiptap/core"
import type { UploadFolder } from "@repo/fika-shared/src/upload-folder.js"
import { insertImageIntoEditor } from "./insert-image-into-editor"

async function insertImageOptimistically({
  editor,
  pos,
  file,
  uploadFolder,
}: {
  editor: Editor
  pos: number
  file: File
  uploadFolder: UploadFolder
}) {
  await insertImageIntoEditor({
    editor,
    file,
    uploadFolder,
    insertAt: pos,
  })
}

export function onDrop({
  editor,
  files,
  pos,
  uploadFolder,
}: {
  editor: Editor
  files: File[]
  pos: number
  uploadFolder: UploadFolder
}) {
  for (const file of files) {
    if (!file.type.startsWith("image/")) continue
    insertImageOptimistically({ editor, pos, file, uploadFolder })
  }
}

export function onPaste({
  editor,
  files,
  uploadFolder,
}: {
  editor: Editor
  files: File[]
  uploadFolder: UploadFolder
}) {
  for (const file of files) {
    if (!file.type.startsWith("image/")) continue

    const pos = editor.state.selection.anchor
    insertImageOptimistically({ editor, pos, file, uploadFolder })
  }
}
